<template>
<div class="modal-card" ref="element">

    <header class="modal-card-head">
    <p class="modal-card-title">Existing resources</p>
    </header>

    <section class="modal-card-body" >
        <div v-if="noResources">There are no existing PDF resources yet.</div>
        <main class="grid">
        <div v-for="(pd,id) in libPdfs" :key="id">
            <!--<img :src="im.url" @click="selectPdf(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">-->
            <div style="position:relative;">
            <iframe
    :src="pd.url"
    frameBorder="0"
    height="100%"
    width="100%"
    style="background: #FFFFFF"
></iframe>
            </div>
            <span class="caption" @click="selectPdf(pd.url, pd.name, pd.file)" :style="pd.url === selectedUrl ? 'font-weight: bold' : ''" style="cursor:pointer">{{pd.name}}</span>
        </div>
        </main>
    </section>
    <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
        <p><b>Selected PDF: </b>{{selectedName}}</p>
</footer>

    <footer class="modal-card-foot">
    <b-button type="is-info" v-if="!noResources" @click="uploadPdf()">Select</b-button>
    <b-button type="is-light" @click="closeModal()">Cancel</b-button>
    </footer>

</div>
</template>

<script>

export default {
  name: 'PdfsLibrary',
  props: ['propParent'],
  data: () => {
    return {
      libPdfs: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      noResources: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    if (this.$store.state.playlists === null) {
      this.loadingComponent.close()
      this.noResources = true
    } else {
      var pl = this.$store.state.playlists
      var hasPdfs = false
      for (let playlist in pl) {
        var objectRef = Object.assign({}, this.$store.getters.getPlaylist(playlist))
        if (objectRef.items) {
          var itemsP = [...objectRef.items.filter(x => x)]
          var ext = null
          for (let i = 0; i < itemsP.length; i++) {
            if (itemsP[i].resourceName) {
              ext = itemsP[i].resourceName.split('.')[1]
              if (ext === 'pdf') {
                hasPdfs = true
                break
              }
            }
          }
        }
      }
      if (hasPdfs === false) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        for (let playlist in this.$store.state.playlists) {
          var playlistDirsRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + playlist)
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + playlist)
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  if (blob.type === 'application/pdf') {
                    var file = new File([blob], fileRef.name, {type: blob.type})
                    this.libPdfs.push({ 'name': fileRef.name, 'url': url, 'file': file })
                    this.globalLogger(this.libPdfs, 'LIB PDFS')
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectPdf (url, name, file) {
      this.globalLogger('select pdf')
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadPdf () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
display: grid;
grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
grid-gap:20px;
align-items: center;
}
.grid iframe {
box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
max-width: 100%;
max-height: 50%;
}
.active {
border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/PdfsLibrary.vue